import { createSelector } from "@ngrx/store";
import { storeSelector } from "../../../store/store.selector";

export const selectSituazioniRuoli = createSelector(
  storeSelector,
  (statiDashboard) => statiDashboard.situazioneRuoli
);

export const selectRolesState = createSelector(
  selectSituazioniRuoli,
  (situazioneRuoli) => situazioneRuoli.ruoli || []
);

export const selectPermissionsState = createSelector(
  selectSituazioniRuoli,
  (situazioneRuoli) => situazioneRuoli.permessi || []
);
